"use strict";

window.vfitzKey = 'vfitz'
let HOST_API = 'https://vfitz.tirewheelconnect.com/whapi/shopify/faceshop'
let DOMAIN = 'monster-parts.myshopify.com'

// whpicker scope environment variable
let vfitzKey = window[window.vfitzKey] = {
  fn: {},
  data: {}
}

// load script file
vfitzKey.loadScript = function (url) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement("script");
    script.onload = resolve;
    script.onerror = reject;
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  });
};


// load jQuery file
vfitzKey.loadCustomJS = async function () {
  return await vfitzKey.loadScript(`${HOST_API}/js?domain=${DOMAIN}`)
};


// load jQuery file
vfitzKey.loadjQuery = async function () {
  if ((typeof jQuery === "undefined") || (jQuery.fn.jquery.replace(/\.(\d)/g, ".0$1").replace(/\.0(\d{2})/g, ".$1") < "1.08.01")) {
    return await vfitzKey.loadScript("//code.jquery.com/jquery-1.12.4.min.js")
  } else {
    return await Promise.resolve();
  }
};


vfitzKey.fn.loadJson = async function (data) {
  const url = `${HOST_API}/pickdataFaceShopSelect2`
  data.path = window.location.pathname
  data.domain = DOMAIN
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "GET",
      dataType: 'json',
      url: url,
      data: data,
      success: resolve,
      error: reject
    })
  })
};

vfitzKey.fn.matchingJson = async function (data) {
  data.path = window.location.pathname
  data.domain = DOMAIN
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      dataType: 'json',
      url: `${HOST_API}/matchingFaceShop`,
      data: data,
      success: resolve,
      error: reject
    })
  })
};

vfitzKey.fn.dataJson = async function (data) {
  data.path = window.location.pathname
  data.domain = DOMAIN
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      dataType: 'json',
      url: `${HOST_API}/productsFaceShop`,
      data: data,
      success: resolve,
      error: reject
    })
  })
};

vfitzKey.fn.queryDataJson = async function (data) {
  data.path = window.location.pathname
  data.domain = DOMAIN
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: "POST",
      dataType: 'json',
      url: `${HOST_API}/queryDataFaceShop`,
      data: data,
      success: resolve,
      error: reject
    })
  })
};

vfitzKey.fn.loadingSelector = function (selector, type) {
  $(selector).prop('disabled', true)
  $(selector + ' option').remove()
  $(selector).append('<option value ="-"> please wait ... </option>')

  if (select2isShow(selector, type)) setSelect2(selector, [], '')
};

// set once picker menu value
vfitzKey.fn.setOnecSelectValue = function (data, selector, type) {
  console.log(' vfitzKey.fn.setOnecSelectValue ', data, selector)
  $(selector).prop('disabled', false)
  $(selector + ' option').remove()
  let _option_html = '<option value="' + data.replace(/\+/g, ' ') + `" selected >` + data.replace(/\+/g, ' ') + '</option>'
  $(selector).append($(_option_html))
  if (select2isShow(selector, type)) setSelect2(selector, data)
};

// render picker menu value
vfitzKey.fn.resetSelectValue = function (data, selector, type, selected) {
  console.log('resetSelectValue', selector, type, selected, data)
  let _type = type;
  let _prefix = '';
  let _suffix = '';
  let _selected = selected ? selected : null;
  if (vfitzCustom && vfitzCustom.menu && vfitzCustom.menu.text[type]) {
    _type = vfitzCustom.menu.text[type]
  }
  if (vfitzCustom && vfitzCustom.menu && vfitzCustom.menu.text['prefix']) {
    _prefix = vfitzCustom.menu.text['prefix'] + ' '
  }
  if (vfitzCustom && vfitzCustom.menu && vfitzCustom.menu.text['suffix']) {
    _suffix = ' ' + vfitzCustom.menu.text['suffix']
  }

  //   console.log('--------', vfitzCustom.menu.text, type, _prefix, _type, _suffix)
  let placeholder = _prefix + _type.firstUpperCase() + _suffix;
  $(selector).prop('disabled', false)
  $(selector + ' option').remove()
  $(selector).append('<option></option>')
  if (_selected) {
    $.each(data, function (index, value) {
      if (_selected == value.id) data[index]['selected'] = true;
    })
  }

  if (select2isShow(selector, type)) setSelect2(selector, data, placeholder)

  console.log('===', data)

};

vfitzKey.fn.openSelect2 = function (selector, type) {
  console.log('vfitzKey.fn.openSelect2', selector, type)
  if (select2isShow(selector, type)) {
    $(selector).select2('open')
  }
};

function select2isShow(selector, type) {
  if (vfitzCustom && vfitzCustom.menu && !vfitzCustom.menu.show[type]) {
    $(selector).hide()
    return false
  } else {
    return true
  }

}

function setSelect2(selector, data, placeholder) {
  let _selector = selector || null;
  let _data = data || [];
  let _placeholder = placeholder || 'Selects options...'
  let _minimumResultsForSearch = (vfitzCustom && vfitzCustom.menu && vfitzCustom.menu.search) ? vfitzCustom.menu.search : Infinity

  console.log($, $(selector), $(selector).select2)

  $(selector).select2({
    width: 'resolve',
    data: data,
    minimumResultsForSearch: _minimumResultsForSearch,
    placeholder: _placeholder,
    selectionCssClass: 'vfitz_select2_selection',
    dropdownParent: $('#vfitz-select2-dropdown-parent'),
    theme: 'bootstrap4',
  });
}



function formatState(state) {
  if (!state.id) {
    return state.text;
  }
  var $state = $(
    '<span style="display: flex; align-items: center;"><img style="height: 16px;" src="' + state.img + '" class="img-flag" /> ' + state.text + '</span>'
  );
  return $state;
};

// 
String.prototype.firstUpperCase = function () {
  return this.replace(/\b(\w)(\w*)/g, function ($0, $1, $2) {
    return $1.toUpperCase() + $2.toLowerCase();
  });
};

vfitzKey.fn.getURLVariable = function (variable) {
  var query = window.location.search.substring(1);
  console.log('vfitz.js query', query)
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) { return decodeURIComponent(pair[1]); }
  }
  return (false);
};